export default __webpack_public_path__ + "static/media/list-ul.92e2fc55.svg";